export function isAndroid() {
    if (typeof window === 'undefined') {
        return false;
    }
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}
// Not quite camel-case...
export function isiOS() {
    if (typeof window === 'undefined') {
        return false;
    }
    return ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform) ||
        // iPadOS 13 reports that it's a Mac...
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document));
}
export function getSafariVersion() {
    if (typeof window === 'undefined') {
        return false;
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('chrom') > -1 || ua.indexOf('safari') === -1) {
        return false;
    }
    var matches = ua.match(/version\/(\d+)/) || [];
    if (!matches.length) {
        return false;
    }
    return parseInt(matches[1]);
}
export function isDumbChromeIOS() {
    if (typeof window === 'undefined') {
        return false;
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.includes('crios')) {
        return true;
    }
    return false;
}
export function scrollTo(el, x, y) {
    if (typeof window === 'undefined') {
        return;
    }
    if ('scrollBehavior' in document.documentElement.style) {
        if (typeof x === 'number') {
            return el.scrollTo(x, y);
        }
        return el.scrollTo(x);
    }
    if (typeof x === 'number') {
        return el.scrollTo(x, y);
    }
    return el.scrollTo(x.left, x.top);
}
//# sourceMappingURL=browser.js.map